/**
 * Created by mariushirjanu on 27/02/2020.
 */
import * as _ from 'underscore';
import { FormattingService } from '../../../shared/services/formatting.service';
import { IReportRow } from '../../../shared/report/report-data.service';
import { HttpDataService } from '../../../shared/http/http-data.service';
import { GaVersion, IBrowseListComponentAttributes, IBrowseListComponentConfig, IBrowseListConfig, IGA2BrowselistInputBindings, IGA2BrowselistOutputBindings } from '../../../shared/browselists/browselists-config.service';
import { Component, Type } from '@angular/core';
import { IObject } from '../../../../type_definitions/datatypes';
import { DialogSize, GaMessageService, IDialog } from '../../../shared/message/ga-message.service';
import { GaDeferredService } from '../../../shared/services/ga-deferred.service';

import { util } from '../../../shared/util';
import { InvoiceInfoComponent } from '../../../shared/invoice-info/invoice-info.component';

@Component({
  selector: 'invoice-info-demo',
  template: `
    <h2>Invoice Info Demo</h2>
    Adding some text to be able to test the scroll functionality<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>

    <button class="btn" (click)="showDialog()" [busyButton]="busy">Edit invoice info</button><br><br>

    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum<br><br>
    Lorem ipsum
  `
})
export class InvoiceInfoDemoComponent {
  public busy: boolean;

  constructor(
    private formattingService:FormattingService,
    private httpDataService:HttpDataService,
    private messageService: GaMessageService,
    private deferredService: GaDeferredService
  ) {/***/
  }

  private showGA2AddEditComponentDialog(entity:number | string, config:IBrowseListConfig, entityRow:IReportRow, loadRowFunction:Function, saveFunction:Function): Promise<any> {
    const deferred = this.deferredService.defer();
    let msg;

    const inputBindings: IObject = {
      adding: !entity,
      saving: false,
      title: config.label
    };

    if (util.notNullOrUndefined(entity)) {
      inputBindings.model = entity;
    }

    const outputBindings: IObject = {
      onDialogSaving: dialogOnSaving.bind(this),
      onSave: dialogSave.bind(this),
      onDialogSaved: dialogOnSaved.bind(this),
      onCancel: dialogCancel
    };

    const componentConfig:IBrowseListComponentConfig = <IBrowseListComponentConfig>config.editComponent;
    const componentAttributes: IBrowseListComponentAttributes = <IBrowseListComponentAttributes>componentConfig.component;

    // add component input bindings defined in config and applied it to 'inputBindings' variable
    _.each(componentAttributes.inputBindings, (val: any, bindingKey: string) => {
      let bindingValue: any;

      if (_.isFunction(val)) {
        bindingValue = val.call(this, inputBindings);
      } else {
        bindingValue = val;
      }

      inputBindings[bindingKey] = bindingValue;
    });

    // add component output bindings defined in config and applied it to 'outputBindings' variable
    _.each(componentAttributes.outputBindings, (val: Function, bindingKey: string) => {
      outputBindings[bindingKey] = val.call(this, outputBindings);
    });

    // add data bindings
    if (config.dataBindings) {
      _.each(config.dataBindings, (column:string, dataBinding:string) => {
        inputBindings[dataBinding] = entityRow[column] || column;
      });
    }

    const dialog: IDialog = this.messageService.showDialog({
      component: <Type<any>>componentAttributes.name,
      inputs: inputBindings,
      outputs: outputBindings,
      wrapperComponent: false,
      closeCallback: dialogCancel,
      closeButton: componentAttributes.closeButton,
      size: DialogSize.MD, // default size
      ...(<IBrowseListComponentConfig>config.editComponent).dialogOptions
    });

    function dialogSave(model) {
      dialog.content.inputs.saving = true;
      saveFunction(model)
        .then(savedModel => {
          deferred.resolve(savedModel);
          dialog.hide();
        })
        .finally(() => {
          dialog.content.inputs.saving = false;
        });
    }

    function dialogCancel() {
      deferred.reject('Cancelled');
      dialog.hide();
    }

    function dialogOnSaving(saving) {
      if (saving) {
        msg = this.messageService.showStatusMessage(`Saving ${config.label} ...`);
      } else {
        this.messageService.closeMessage(msg);
      }
    }

    function dialogOnSaved(responseData:any) {
      if (responseData && responseData.id) {
        loadRowFunction(responseData && responseData.id)
          .then(rowData => {
            // after getting row data from this.loadRow() then resolve data to be passed to reports.controller;
            deferred.resolve(rowData);
            dialog.content.inputs.saving = false;

            // destroy dialog and message
            this.messageService.closeMessage(msg);
            dialog.hide();
          });
      } else {
        if (msg) {
          // destroy dialog and message
          this.messageService.closeMessage(msg);
        }

        dialogCancel();
      }
    }

    return deferred.promise;
  }

  public showDialog(): void {
    console.log('Show Dialog');

    const config: IBrowseListConfig = {
      reportId: 242,
      label: 'Invoice Address',
      restPath: 'rest/orderentry/orders/',
      editComponent: {
        use: GaVersion.GA2,
        component: {
          name: InvoiceInfoComponent,
          inputBindings: {
            orderData: (inputBindings: IGA2BrowselistInputBindings) => inputBindings.model
          },
          outputBindings: {
            onSaving: (outputBindings: IGA2BrowselistOutputBindings) => outputBindings.onDialogSaving,
            onSaved: (outputBindings: IGA2BrowselistOutputBindings) => outputBindings.onDialogSaved,
            onCancel: (outputBindings: IGA2BrowselistOutputBindings) => outputBindings.onCancel
          }
        }
      },
      addComponent: '=editComponent',
      dataBindings: {
        idKey: 'Dereqid'
      },
      noDelete: true,
      noAdd: true
    };

    // @ts-ignore
    const entityRow: IReportRow = {
      Dedelst_ds: 'WAITING FOR KUNDENNR',
      Deorddt: '2020-02-25T00:00:00Z',
      Deicomn: 'BMW PARTNERS',
      Deistre: 'Lahnstraße 34-40',
      Pending_address: '',
      Oldeditscreen: {
        value: '',
        properties: {
          label: 'Old edit screen',
          idKey: 'Dereqid',
          ga1EditUrl: '/unacc/O_BillToView_Edit.jsp?row0_Dereqid=154351&ejbEvent=edit&browseList=true'
        }
      },
      Deicity: '60326',
      Deiloci: 47617,
      Deizipc: '60326',
      Closecomment: '',
      Pending_vat: '',
      Lacomnm: 'BECHTLE GMBH & CO. KG',
      Dereqid: {
        value: 154351,
        properties: {
          linkType: 'ORDER_EDIT',
          orderId: 154351
        }
      },
      Decounm: 'GERMANY',
      Pacomnm: 'BECHTLE GMBH & CO. KG',
      Ivcounm: 'GERMANY',
      Deivatn: 'DE281574421',
      Odlname: 'Bogdan Danut',
      Delamnm: 'GERMANY',
      Deident: 'KUNDENNR',
      Desprnm: 'BMW PARTNERS',
      Pendingcomment: '',
      Detestr_ds: ''
    };

    const loadRowFunction = () => {
      console.log('Called loadRowFunction');
    };

    const saveFunction = () => {
      console.log('Called saveFunction');
      return Promise.resolve();
    };

    this.busy = true;
    this.loadEntityId(`${config.restPath}64175`)
      .then((entity) => {
        this.showGA2AddEditComponentDialog(<any>entity, config, entityRow, loadRowFunction, saveFunction)
          .finally(() => {
            this.busy = false;
            console.log('Done');
          });
      });
  }

  private loadEntityId(url): Promise<any> {
    return this.httpDataService.doGET(
      url,
      undefined,
      undefined,
      'Error loading entity'
    );
  }
}